(function () {
  var currentScript = document.currentScript;
  if (!currentScript || currentScript.dataset.tk9ProofStatsLoaded === 'true') return;
  currentScript.dataset.tk9ProofStatsLoaded = 'true';

  var DEFAULT_LOOX_PUBLIC_STORE_ID = 'Vk-j_W8R7p.25e4be31678098b0217af85f8fff1e485d348efd1508b557b1a637bb8607383a';
  var LOOX_BASE_URL = 'https://storefront-api.loox.io/storefront/v1/store/';
  var looxCache = {};

  var config = {
    customerCount: parseCount(currentScript.getAttribute('data-customer-count')),
    customerEndpoint: currentScript.getAttribute('data-customer-endpoint') || '',
    reviewCount: parseCount(currentScript.getAttribute('data-review-count')) || 9240,
    reviewRating: currentScript.getAttribute('data-review-rating') || '4.9/5',
    socialLabel: currentScript.hasAttribute('data-social-label') ? currentScript.getAttribute('data-social-label') : '290K+ social followers',
    socialUrl: currentScript.hasAttribute('data-social-url') ? currentScript.getAttribute('data-social-url') : 'https://www.instagram.com/teamk9/',
    socialEnabled: !(currentScript.hasAttribute('data-social-label') && currentScript.getAttribute('data-social-label') === ''),
    refreshMs: Math.max(15000, parseInt(currentScript.getAttribute('data-refresh-ms') || '60000', 10)),
    looxPublicStoreId: currentScript.getAttribute('data-loox-public-store-id') || DEFAULT_LOOX_PUBLIC_STORE_ID,
    looxEnabled: currentScript.getAttribute('data-loox-enabled') !== 'false',
    looxReviewCountSource: false
  };

  var formatter = new Intl.NumberFormat('en-US');
  var proofContainers = [
    '.tk9-blog-hub__trust',
    '.tk9-tips-proof-strip .wrap',
    '.bw-trust-row',
    '.bw-proof-strip',
    '[aria-label*="trust signal" i]',
    '[aria-label*="proof" i]'
  ];

  function currentPath() {
    return String(window.location && window.location.pathname || '').toLowerCase();
  }

  function isCommerceListingPage() {
    var path = currentPath();
    return path === '/' ||
      path.indexOf('/collections/') === 0 ||
      path.indexOf('/search') === 0;
  }

  function hasExplicitLooxHydrationTargets() {
    return Boolean(document.querySelector('[data-tk9-loox-bottomline], [data-tk9-loox-reviews], .tk9-editorial-rail, iframe[name="looxReviewsFrame"], iframe#looxReviewsFrame'));
  }

  function shouldRunFullProofHydration() {
    if (!document.body) return false;
    if (document.body.getAttribute('data-tk9-proof-full') === 'true') return true;
    if (isCommerceListingPage() && !hasExplicitLooxHydrationTargets()) return false;
    return hasExplicitLooxHydrationTargets();
  }

  function parseCount(value) {
    var parsed = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function roundedCustomerLabel(count) {
    if (!count) return '';
    var rounded = Math.floor(count / 50000) * 50000;
    if (rounded < 1) return formatter.format(count) + ' Verified Buyers';
    return formatter.format(rounded) + '+ Verified Buyers';
  }

  function ratingValue(value) {
    var parsed = Number(value || 0);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function ratingLabel(value) {
    var rating = ratingValue(value);
    return rating ? rating.toFixed(1).replace(/\.0$/, '') + '/5' : config.reviewRating;
  }

  function reviewLabel(count) {
    var total = parseCount(count) || config.reviewCount;
    return formatter.format(total) + ' ' + (total === 1 ? 'featured review' : 'featured reviews');
  }

  function fullReviewLabel(includeRating) {
    return includeRating ? config.reviewRating + ' from featured reviews' : reviewLabel(config.reviewCount);
  }

  function publishedReviewLabel() {
    return formatter.format(config.reviewCount) + ' published reviews';
  }

  function publishedCustomerProof() {
    return 'Trusted by 200,000+ Verified Buyers, with a ' + config.reviewRating + ' average from ' + formatter.format(config.reviewCount) + ' published customer reviews.';
  }

  function starText(value) {
    var rating = Math.round(ratingValue(value));
    if (!rating) return '★★★★★';
    return '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(0, 5 - rating);
  }

  function shouldSkipNode(node) {
    var parent = node.parentElement;
    if (!parent) return true;
    if (parent.closest('script,style,noscript,template,svg,head,[data-tk9-proof-stats-processed]')) return true;
    if (parent.closest('[aria-hidden="true"]')) return true;
    return false;
  }

  function pathLooksNonProductEditorial() {
    var path = String(window.location && window.location.pathname || '').toLowerCase();
    return /favorite-toy|best-thing-they-own/.test(path) && /comfort|sad/.test(path);
  }

  function inNonProductEditorial(node) {
    var editorial = node && node.closest ? node.closest('.tk9-editorial') : document.querySelector('.tk9-editorial');
    if (!editorial) return false;
    if (editorial.getAttribute('data-tk9-product-context') === 'true') return false;
    if (editorial.getAttribute('data-tk9-product-context') === 'false') return true;
    return pathLooksNonProductEditorial();
  }

  function removeEditorialProductProof() {
    document.querySelectorAll('.tk9-editorial').forEach(function (editorial) {
      if (!inNonProductEditorial(editorial)) return;
      editorial
        .querySelectorAll([
          '.tk9-editorial-shop',
          '[data-tk9-article-loox-reviews]'
        ].join(','))
        .forEach(function (node) {
          var removable = node.closest('.tk9-editorial-rail-review, .tk9-editorial-rail-products, .tk9-editorial-shop') || node;
          removable.remove();
        });
    });
  }

  function replaceInTextNode(node) {
    if (shouldSkipNode(node)) return;
    var text = node.nodeValue || '';
    var next = text;
    var customer = roundedCustomerLabel(config.customerCount);

    if (customer) {
      next = next
        .replace(/\bJoin\s+(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:happy\s+)?customers\b/gi, customer)
        .replace(/\bOver\s+(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:Happy\s+)?Customers\b/g, customer)
        .replace(/\b(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(Team K9\s+)?(?:happy\s+)?customers\b/gi, customer)
        .replace(/\b(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:Team K9\s+)?dog parents\b/gi, customer);
    }

    next = next
      .replace(/#1 Choice of Loving Dog Parents Since 2018/g, 'Trusted by Dog Parents Since 2018')
      .replace(/Join 215,793 dog parents who've discovered the secret to deeper connection\./g, "Join 200,000+ Verified Buyers who've discovered gear made for everyday dog life.")
      .replace(/Our vet recommended this brand!/g, 'Verified Team K9 customer review')
      .replace(/Best purchase I've made for my dog\. Worth every penny!/g, 'Featured customer reviews are shown through Loox.')
      .replace(/Trusted by 200,000\+ Verified Buyers, with 9,256 featured reviews averaging 4\.9\/5\./g, publishedCustomerProof())
      .replace(/Trusted by 200,000\+ Verified Buyers with 9,256 reviews and a 4\.9\/5 average rating\./g, publishedCustomerProof())
      .replace(/verified Loox reviews for this Team K9 product or its matching setup/gi, 'featured Loox reviews for this Team K9 product or its matching setup')
      .replace(/real Loox reviews/gi, 'featured Loox reviews')
      .replace(/\b9,000\+\s+store reviews\b/gi, publishedReviewLabel())
      .replace(/\b9,000\+\s+reviews\b/gi, publishedReviewLabel())
      .replace(/\b9,161\+\s+Reviews\b/g, publishedReviewLabel())
      .replace(/\b9,161\s+reviews\b/gi, publishedReviewLabel())
      .replace(/\b9,213\s+(?:Loox\s+)?reviews\b/gi, publishedReviewLabel())
      .replace(/\b9,240\s+reviews\b/gi, publishedReviewLabel())
      .replace(/\b4\.9\/5\s*\(\s*9,161\+?\s+Reviews\s*\)/gi, fullReviewLabel(true))
      .replace(/\b4\.9\/5\s*\(\s*9,000\+\s+Reviews\s*\)/gi, fullReviewLabel(true))
      .replace(/\b4\.9\/5\s+9,\d{3}\s+reviews\b/gi, fullReviewLabel(true));

    if (next !== text) node.nodeValue = next;
  }

  function scanText() {
    if (!document.body) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceInTextNode);
  }

  function addSocialProof() {
    if (!document.body || !config.socialEnabled || !config.socialLabel) return;
    proofContainers.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (container) {
        if (container.dataset.tk9SocialProofAdded === 'true') return;
        var text = container.innerText || '';
        if (!/(review|customer|dog parent|guarantee|trust|proof)/i.test(text)) return;
        if (/social followers|Instagram|TikTok/i.test(text)) return;

        var span = document.createElement('span');
        span.className = 'tk9-proof-stat tk9-proof-stat--social';
        if (config.socialUrl) {
          var link = document.createElement('a');
          link.href = config.socialUrl;
          link.textContent = config.socialLabel;
          link.rel = 'noopener';
          span.appendChild(link);
        } else {
          span.textContent = config.socialLabel;
        }
        container.appendChild(span);
        container.dataset.tk9SocialProofAdded = 'true';
      });
    });
  }

  function hasCustomerPrivacyApi() {
    return window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function';
  }

  function wirePrivacyOptOutLinks() {
    if (!document.body) return;
    document.querySelectorAll('a').forEach(function (link) {
      if (!/do not sell or share my personal information/i.test(link.textContent || '')) return;
      if (link.dataset.tk9PrivacyOptOut === 'true') return;
      link.dataset.tk9PrivacyOptOut = 'true';
      link.href = '#privacy-opt-out';
      link.setAttribute('role', 'button');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (!hasCustomerPrivacyApi()) {
          window.location.href = 'mailto:support@teamk9.com?subject=Do%20Not%20Sell%20or%20Share%20My%20Personal%20Information';
          return;
        }
        window.Shopify.customerPrivacy.setTrackingConsent(
          { sale_of_data: false, analytics: false, marketing: false },
          function () {
            var previous = link.textContent;
            link.textContent = 'Privacy choice saved';
            window.setTimeout(function () {
              link.textContent = previous || 'Do Not Sell or Share My Personal Information';
            }, 3500);
          }
        );
      });
    });
  }

  function injectStyle() {
    if (document.getElementById('tk9-proof-stats-style')) return;
    var style = document.createElement('style');
    style.id = 'tk9-proof-stats-style';
    style.textContent = [
      '.tk9-proof-stat a{color:inherit;text-decoration:none}',
      '.tk9-proof-stat a:hover{text-decoration:underline}',
      '.tk9-loox-review-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:14px}',
      '.tk9-loox-review-card{border:1px solid rgba(20,20,20,.12);border-radius:8px;background:#fff;color:#171717;overflow:hidden}',
      '.tk9-loox-review-card__media{aspect-ratio:4/3;background:#f4f1ec;overflow:hidden}',
      '.tk9-loox-review-card__media img,.tk9-loox-review-card__media video{width:100%;height:100%;object-fit:cover;display:block}',
      '.tk9-loox-review-card__body{display:grid;gap:8px;padding:14px}',
      '.tk9-loox-review-card__stars{color:#bf7d1f;font-size:13px;letter-spacing:0}',
      '.tk9-loox-review-card blockquote{margin:0;font:inherit;line-height:1.42}',
      '.tk9-loox-review-card cite{font-style:normal;font-size:12px;opacity:.72}',
      '.tk9-editorial-rail-loox{background:linear-gradient(180deg,rgba(249,181,46,.16),transparent 42%),#fff;border-color:rgba(249,181,46,.42)}',
      '.tk9-editorial-rail-loox__stars{color:#f9b52e;font-size:18px;letter-spacing:0;line-height:1;margin:6px 0 10px}',
      '.tk9-editorial-rail-loox-reviews{background:#fff;border-color:rgba(15,159,144,.24)}',
      '.tk9-editorial-rail-loox-reviews [data-tk9-loox-reviews]>p{color:#64748b;font-size:13px;font-weight:800;line-height:1.35;margin:8px 0 0}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-grid{display:grid;gap:12px;grid-template-columns:1fr;margin-top:12px}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card{border:1px solid rgba(15,23,42,.12);border-radius:14px;box-shadow:none;overflow:hidden}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card__media{aspect-ratio:4/3;max-height:168px}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card__body{gap:7px;padding:12px}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card__stars{color:#f9b52e;font-size:12px;letter-spacing:0}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card blockquote{color:#0f172a;font-size:13px;font-weight:800;line-height:1.35}',
      '.tk9-editorial-rail-loox-reviews .tk9-loox-review-card cite{color:#64748b;font-size:12px;font-weight:800}',
      '.tk9-loox-featured-heading{color:#111827;font-size:clamp(22px,2.2vw,32px);font-weight:850;letter-spacing:0;line-height:1.1;margin:0 auto 14px;max-width:1080px;padding:0 16px;text-align:left}',
      '@media(max-width:749px){.tk9-loox-featured-heading{font-size:22px;margin-bottom:12px;padding:0 18px;text-align:center}.loox-trust-badge-container{max-width:100%;min-width:0}.loox-trust-badge-widget{max-width:100%;min-width:0;overflow:hidden}.loox-trust-badge-widget-content,.loox-trust-badge-widget-content-container{min-width:0;max-width:100%;flex-wrap:wrap;gap:6px 10px;justify-content:center}.loox-trust-badge-widget-ratings{min-width:0;max-width:100%;flex-wrap:wrap;justify-content:center}.loox-trust-badge-widget-ratings__stars{flex:0 1 auto;max-width:120px}.loox-trust-badge-widget-ratings__average-rating{font-size:18px;line-height:1.15;white-space:nowrap}.loox-trust-badge-widget-ratings__raters{font-size:16px;line-height:1.15;text-align:center;white-space:normal;word-break:normal}.loox-trust-badge-widget-ratings__raters:before{content:none!important;display:none!important}.loox-trust-badge-widget-ratings__raters-count,.loox-trust-badge-widget-ratings__raters-title{display:inline;white-space:nowrap}.loox-trust-badge-widget-ratings__raters-count:after{content:\" \"}.tk9-home-page .loox-v2-carousel-container iframe[id*=\"LOOX-V2_CAROUSEL\"]{pointer-events:none!important}.tk9-home-page .loox-v2-carousel-container{touch-action:pan-y!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function syncAggregateLooxWidget() {
    var widget = document.querySelector('.tpb-loox[data-raters], .loox-rating[data-id="27154364"][data-raters]');
    if (!widget) return;
    var count = parseCount(widget.getAttribute('data-raters'));
    var rating = ratingValue(widget.getAttribute('data-rating'));
    if (count) {
      config.reviewCount = count;
      config.looxReviewCountSource = true;
    }
    if (rating) config.reviewRating = ratingLabel(rating);
  }

  function emitLooxEvent(name, detail) {
    var eventName = 'teamk9_loox_' + name;
    var payload = Object.assign({ event: eventName }, detail || {});
    document.dispatchEvent(new CustomEvent('teamk9:loox:' + name, { detail: payload }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function looxUrl(path, params) {
    var url = new URL(LOOX_BASE_URL + encodeURIComponent(config.looxPublicStoreId) + path);
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value !== undefined && value !== null && value !== '') url.searchParams.set(key, value);
    });
    return url.toString();
  }

  async function fetchLoox(path, params) {
    if (!config.looxEnabled || !config.looxPublicStoreId || !window.fetch) return null;
    var url = looxUrl(path, params);
    if (looxCache[url]) return looxCache[url];

    looxCache[url] = fetch(url, {
      cache: 'no-store',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(async function (response) {
        var data = await response.json().catch(function () { return null; });
        if (!response.ok) {
          emitLooxEvent('error', { status: response.status, code: data && data.error && data.error.code });
          return null;
        }
        return data;
      })
      .catch(function (error) {
        emitLooxEvent('error', { message: error && error.message ? error.message : 'Loox request failed' });
        return null;
      });

    return looxCache[url];
  }

  function inferProductId() {
    var analyticsProductId = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id;
    if (analyticsProductId) return String(analyticsProductId);
    var node = document.querySelector('[data-tk9-loox-product-id],[data-product-id]');
    if (node) return node.getAttribute('data-tk9-loox-product-id') || node.getAttribute('data-product-id') || '';
    var meta = document.querySelector('meta[property="product:retailer_item_id"],meta[name="product:id"]');
    return meta ? meta.getAttribute('content') || '' : '';
  }

  async function getLooxBottomline(options) {
    var scope = options && options.scope === 'store' ? 'store' : 'product';
    var productId = options && options.productId ? String(options.productId) : '';
    var path = scope === 'store' ? '/store-reviews/bottomline' : '/product-reviews/bottomline' + (productId ? '/' + encodeURIComponent(productId) : '');
    return fetchLoox(path);
  }

  async function getLooxReviews(options) {
    var opts = options || {};
    var scope = opts.scope === 'store' ? 'store' : 'product';
    var params = {
      page: opts.page || 1,
      limit: Math.min(250, Math.max(1, parseCount(opts.limit) || 6)),
      sort: opts.sort || 'featured',
      direction: opts.direction || 'desc',
      rating: opts.rating || ''
    };
    if (scope === 'product' && opts.productId) params.product_id = opts.productId;
    return fetchLoox(scope === 'store' ? '/store-reviews' : '/product-reviews', params);
  }

  function isValidBottomline(data) {
    return data && Number.isFinite(Number(data.totalReviews)) && Number.isFinite(Number(data.averageRating));
  }

  function targetsFor(root, selector) {
    var nodes = [];
    if (root.matches && root.matches(selector)) nodes.push(root);
    root.querySelectorAll(selector).forEach(function (node) { nodes.push(node); });
    return nodes;
  }

  function setTargetText(root, selector, value) {
    targetsFor(root, selector).forEach(function (node) {
      node.textContent = value;
    });
  }

  function hydrateBottomlineElement(element, bottomline) {
    var total = parseCount(bottomline.totalReviews);
    var average = ratingValue(bottomline.averageRating);
    element.dataset.tk9LooxLoaded = 'true';
    element.dataset.tk9LooxTotalReviews = String(total);
    element.dataset.tk9LooxAverageRating = String(average);
    setTargetText(element, '[data-tk9-loox-rating]', ratingLabel(average));
    setTargetText(element, '[data-tk9-loox-average]', average.toFixed(1).replace(/\.0$/, ''));
    setTargetText(element, '[data-tk9-loox-review-count]', reviewLabel(total));
    setTargetText(element, '[data-tk9-loox-review-count-number]', formatter.format(total));
    setTargetText(element, '[data-tk9-loox-stars]', starText(average));
    Object.keys(bottomline.ratingDistribution || {}).forEach(function (rating) {
      setTargetText(element, '[data-tk9-loox-distribution="' + rating + '"]', formatter.format(parseCount(bottomline.ratingDistribution[rating])));
    });
  }

  async function hydrateBottomlines() {
    var elements = Array.from(document.querySelectorAll('[data-tk9-loox-bottomline]'));
    if (!elements.length) return;

    await Promise.all(elements.map(async function (element) {
      if (inNonProductEditorial(element)) {
        removeEditorialProductProof();
        return;
      }
      if (element.dataset.tk9LooxLoaded === 'true') return;
      var scope = element.getAttribute('data-tk9-loox-bottomline') === 'store' ? 'store' : 'product';
      var productId = element.getAttribute('data-tk9-loox-product-id') || (scope === 'product' ? inferProductId() : '');
      var bottomline = await getLooxBottomline({ scope: scope, productId: productId });
      if (isValidBottomline(bottomline)) hydrateBottomlineElement(element, bottomline);
    }));
  }

  function compactReviewBody(value) {
    var clean = String(value || '').replace(/\s+/g, ' ').trim();
    if (clean.length <= 220) return clean;
    return clean.slice(0, 217).replace(/\s+\S*$/, '') + '...';
  }

  function createReviewCard(review) {
    var article = document.createElement('article');
    article.className = 'tk9-loox-review-card';
    article.setAttribute('data-tk9-loox-review-id', review.id || '');

    var media = Array.isArray(review.media) ? review.media.find(function (item) { return item && item.url; }) : null;
    if (media) {
      var mediaWrap = document.createElement('div');
      mediaWrap.className = 'tk9-loox-review-card__media';
      if (media.type === 'video') {
        var video = document.createElement('video');
        video.src = media.url;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        mediaWrap.appendChild(video);
      } else {
        var image = document.createElement('img');
        image.src = media.url;
        image.loading = 'lazy';
        image.alt = 'Customer review media for ' + (review.product && review.product.name ? review.product.name : 'Team K9');
        mediaWrap.appendChild(image);
      }
      article.appendChild(mediaWrap);
    }

    var body = document.createElement('div');
    body.className = 'tk9-loox-review-card__body';

    var stars = document.createElement('div');
    stars.className = 'tk9-loox-review-card__stars';
    stars.textContent = starText(review.rating);
    body.appendChild(stars);

    var quote = document.createElement('blockquote');
    quote.textContent = compactReviewBody(review.body);
    body.appendChild(quote);

    var cite = document.createElement('cite');
    var name = review.reviewer && review.reviewer.name ? review.reviewer.name : 'Team K9 customer';
    var verified = review.verified ? ' verified buyer' : ' customer review';
    cite.textContent = name + ',' + verified;
    body.appendChild(cite);

    article.appendChild(body);
    return article;
  }

  async function hydrateReviewLists() {
    var containers = Array.from(document.querySelectorAll('[data-tk9-loox-reviews]'));
    if (!containers.length) return;

    await Promise.all(containers.map(async function (container) {
      if (inNonProductEditorial(container)) {
        removeEditorialProductProof();
        return;
      }
      if (container.dataset.tk9LooxLoaded === 'true') return;
      var scope = container.getAttribute('data-tk9-loox-reviews') === 'store' ? 'store' : 'product';
      var productId = container.getAttribute('data-tk9-loox-product-id') || (scope === 'product' ? inferProductId() : '');
      var limit = parseCount(container.getAttribute('data-tk9-loox-limit')) || 6;
      var response = await getLooxReviews({
        scope: scope,
        productId: productId,
        limit: limit,
        sort: container.getAttribute('data-tk9-loox-sort') || 'featured',
        direction: container.getAttribute('data-tk9-loox-direction') || 'desc',
        rating: container.getAttribute('data-tk9-loox-rating-filter') || ''
      });
      var reviews = response && Array.isArray(response.reviews) ? response.reviews : [];
      if (container.getAttribute('data-tk9-loox-require-media') === 'true') {
        reviews = reviews.filter(function (review) { return Array.isArray(review.media) && review.media.length; });
      }
      if (!reviews.length) return;

      var grid = document.createElement('div');
      grid.className = 'tk9-loox-review-grid';
      reviews.slice(0, limit).forEach(function (review) {
        grid.appendChild(createReviewCard(review));
      });
      container.replaceChildren(grid);
      container.dataset.tk9LooxLoaded = 'true';
      emitLooxEvent('reviews_loaded', { scope: scope, count: reviews.length, product_id: productId || '' });
    }));
  }

  function ensureArticleLooxRail() {
    var rail = document.querySelector('.tk9-editorial-rail');
    if (!rail || rail.querySelector('.tk9-editorial-rail-loox')) return;
    if (!/article\.team-k9-editorial/i.test(document.querySelector('[data-template]')?.getAttribute('data-template') || '')) return;
    var storyAd = rail.closest('.tk9-editorial') && rail.closest('.tk9-editorial').getAttribute('data-tk9-product-context') !== 'true';

    var bottomline = document.createElement('div');
    bottomline.className = 'tk9-editorial-rail-review tk9-editorial-rail-loox';
    bottomline.setAttribute('data-tk9-loox-bottomline', 'product');
    bottomline.setAttribute('aria-label', 'Verified Team K9 Loox review summary');
    bottomline.innerHTML = [
      '<span class="tk9-mini-kicker">' + (storyAd ? 'Published reviews' : 'Verified Loox reviews') + '</span>',
      '<div class="tk9-editorial-rail-loox__stars" data-tk9-loox-stars>★★★★★</div>',
      '<strong><span data-tk9-loox-rating>4.9/5</span> from <span data-tk9-loox-review-count>9,256 published reviews</span></strong>',
      '<p>' + (storyAd ? 'Real reviews across Team K9 products and everyday dog-parent routines.' : 'Real Team K9 customers use this gear in the routines covered by our setup guides.') + '</p>',
      '<a href="/collections/best-sellers?el=003-smart-rail-loox-bestsellers">Shop best-sellers</a>'
    ].join('');

    var reviews = document.createElement('div');
    reviews.className = 'tk9-editorial-rail-review tk9-editorial-rail-loox-reviews';
    reviews.setAttribute('aria-label', 'Recent verified Loox product reviews');
    reviews.innerHTML = [
      '<span class="tk9-mini-kicker">' + (storyAd ? 'Recent featured reviews' : 'Recent photo reviews') + '</span>',
      '<div data-tk9-loox-reviews="product" data-tk9-loox-limit="3" data-tk9-loox-sort="featured" data-tk9-loox-direction="desc" data-tk9-loox-rating-filter="5" data-tk9-loox-require-media="true">',
      '<p>Loading verified customer reviews...</p>',
      '</div>'
    ].join('');

    var anchor = rail.querySelector('.tk9-editorial-rail-note') || rail.firstElementChild;
    if (anchor && anchor.nextSibling) {
      rail.insertBefore(reviews, anchor.nextSibling);
      rail.insertBefore(bottomline, reviews);
    } else {
      rail.prepend(reviews);
      rail.prepend(bottomline);
    }
  }

  function ensurePdpLooxHeadings() {
    document.querySelectorAll('iframe[name="looxReviewsFrame"], iframe#looxReviewsFrame').forEach(function (iframe) {
      var block = iframe.closest('#looxReviews') || iframe.parentElement;
      if (!block || block.dataset.tk9LooxFeaturedHeading === 'true') return;
      var previous = block.previousElementSibling;
      if (previous && previous.classList && previous.classList.contains('tk9-loox-featured-heading')) {
        block.dataset.tk9LooxFeaturedHeading = 'true';
        return;
      }
      var heading = document.createElement('h3');
      heading.className = 'tk9-loox-featured-heading';
      heading.textContent = 'Featured Reviews';
      block.parentNode.insertBefore(heading, block);
      block.dataset.tk9LooxFeaturedHeading = 'true';
    });
  }

  async function refreshLooxProof() {
    if (!shouldRunFullProofHydration()) return;
    removeEditorialProductProof();
    ensureArticleLooxRail();
    ensurePdpLooxHeadings();
    syncAggregateLooxWidget();
    scanText();
    await hydrateBottomlines();
    await hydrateReviewLists();
  }

  async function refreshCustomerCount() {
    if (!config.customerEndpoint) return;
    try {
      var response = await fetch(config.customerEndpoint, {
        cache: 'no-store',
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        if (response.status === 404 || response.status === 410) config.customerEndpoint = '';
        return;
      }
      var data = await response.json();
      var count = parseCount(data && (data.paidBuyerCount || data.customerCount || data.count || data.counts?.paidBuyers));
      var reviewCount = parseCount(data && (data.reviewCount || data.counts?.reviews));
      var socialLabel = data && (data.socialLabel || data.labels?.socialFollowers);
      if (reviewCount && !config.looxReviewCountSource && reviewCount !== config.reviewCount) config.reviewCount = reviewCount;
      if (config.socialEnabled && socialLabel && socialLabel !== config.socialLabel) config.socialLabel = String(socialLabel);
      if (count && count !== config.customerCount) {
        config.customerCount = count;
        scanText();
      }
      scanText();
      addSocialProof();
    } catch (error) {
      // Leave the verified static proof copy in place if the live endpoint is unavailable.
    }
  }

  function boot() {
    if (window.location && window.location.pathname === '/') document.body.classList.add('tk9-home-page');
    injectStyle();
    window.TeamK9Loox = {
      getBottomline: getLooxBottomline,
      getReviews: getLooxReviews,
      refresh: refreshLooxProof,
      publicStoreId: config.looxPublicStoreId
    };
    syncAggregateLooxWidget();
    scanText();
    addSocialProof();
    wirePrivacyOptOutLinks();
    if (!shouldRunFullProofHydration()) return;
    removeEditorialProductProof();
    ensureArticleLooxRail();
    ensurePdpLooxHeadings();
    observeLateProof();
    refreshCustomerCount();
    refreshLooxProof();
    if (config.customerEndpoint) window.setInterval(refreshCustomerCount, config.refreshMs);
  }

  function observeLateProof() {
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        syncAggregateLooxWidget();
        scanText();
        addSocialProof();
        wirePrivacyOptOutLinks();
        removeEditorialProductProof();
        ensureArticleLooxRail();
        ensurePdpLooxHeadings();
        hydrateBottomlines();
        hydrateReviewLists();
      }, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
